import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Button,
  Dialog,
} from '@ui/components';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

interface BulkEditCostCenterConfirmationDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onConfirm: () => void;
}

export const BulkEditCostCenterConfirmationDialog: FC<BulkEditCostCenterConfirmationDialogProps> = (
  props,
) => {
  const { isOpen, setIsOpen, onConfirm } = props;
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  return (
    <Dialog onOpenChange={setIsOpen} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('VEHICLES.EDIT_COST_CENTER_DIALOG.TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('VEHICLES.EDIT_COST_CENTER_DIALOG.DESCRIPTION')}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="tertiary" type="button" size="large" wide>
              {t('VEHICLES.EDIT_COST_CENTER_DIALOG.CANCEL')}
            </Button>
          </DialogClose>
          <Button onClick={handleConfirm} size="large" wide>
            {t('VEHICLES.EDIT_COST_CENTER_DIALOG.CONFIRM')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
